import { render } from "./PortfolioDetail.vue?vue&type=template&id=619b7b38&scoped=true"
import script from "./PortfolioDetail.vue?vue&type=script&lang=js"
export * from "./PortfolioDetail.vue?vue&type=script&lang=js"

import "./PortfolioDetail.vue?vue&type=style&index=0&id=619b7b38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619b7b38"]])

export default __exports__